const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3RuntimePlus {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'runtimePlus', name: '⚙️ 高度な設定', color1: '#5D5D5D', color2: '#4A4A4A',
            blocks: [
                { opcode: 'setTurbo', blockType: BlockType.COMMAND, text: 'ターボモード [ON]', arguments: { ON: { type: ArgumentType.STRING, menu: 'onOff', defaultValue: 'on' } } },
                { opcode: 'getTurbo', blockType: BlockType.BOOLEAN, text: 'ターボモード？' },
                { opcode: 'setFPS', blockType: BlockType.COMMAND, text: 'FPSを [N] に', arguments: { N: { type: ArgumentType.NUMBER, defaultValue: 60 } } },
                { opcode: 'getCloneCount', blockType: BlockType.REPORTER, text: 'クローン数' },
                { opcode: 'greenFlag', blockType: BlockType.COMMAND, text: '🚩 緑の旗をクリック' },
                { opcode: 'stopAll', blockType: BlockType.COMMAND, text: '🛑 すべてを止める' },
                { opcode: 'getProjectName', blockType: BlockType.REPORTER, text: 'プロジェクト名' }
            ],
            menus: { onOff: { items: ['on', 'off'] } }
        };
    }
    setTurbo(args) { if (this.runtime) this.runtime.turboMode = args.ON === 'on'; }
    getTurbo() { return this.runtime ? this.runtime.turboMode : false; }
    setFPS(args) { if (this.runtime && this.runtime.setFramerate) this.runtime.setFramerate(Cast.toNumber(args.N)); }
    getCloneCount() { return this.runtime ? this.runtime.targets.filter(function(t) { return !t.isOriginal; }).length : 0; }
    greenFlag() { if (this.runtime) this.runtime.greenFlag(); }
    stopAll() { if (this.runtime) this.runtime.stopAll(); }
    getProjectName() { return 'Scratch Project'; }
}
module.exports = Scratch3RuntimePlus;